// export const USER_TYPE = {
//   0: '普通用户',
//   1: '管理员',
//   2: '助力',
//   3: '下单员',
// };
// export const PLATFORM = {
//   1: '币安',
//   2: '火币',
//   3: 'okex',
// };
export const USER_TYPE = ['普通用户', '管理员', '助理', '下单员'];
export const PLATFORM = ['全部', '币安', '火币', 'okex'];

export const CONTRACT_CYCLE = [
  { label: '当周', value: '1', desc: 'weekly' },
  { label: '次周', value: '2', desc: 'biweekly' },
  { label: '当季', value: '3', desc: 'quarterly' },
  { label: '次季', value: '4', desc: 'biquarterly' },
];

export const ACCOUNT_OPTION = [
  // { label: '资金账户', value: '0' },
  { label: '币币账户', value: '1' },
  { label: '交割合约账户', value: '3' },
  // { label: '永续合约账户', value: '9' },
];

export const USER_TYPE_OPTION = [
  { label: '普通用户', value: '0' },
  { label: '管理员', value: '1' },
  { label: '助理', value: '2' },
  { label: '下单员', value: '3' },
];

export const PLATFORM_OPTION = [
  { label: '全部', value: '0' },
  { label: '币安', value: '1' },
  { label: '火币', value: '2' },
  { label: 'okex', value: '3' },
];

export const FUTURE_TYPE = [
  { label: '开多', value: '1' },
  { label: '开空', value: '2' },
  { label: '平多', value: '3' },
  { label: '平空', value: '4' },
];
